import { Box } from "@mui/material"
import React from "react"
import { useCustomBranding } from "../constants/colors"

export default function Background() {
  const { isEnabled, primaryColor } = useCustomBranding()

  return (
    <Box
      position="absolute"
      top={0}
      left={0}
      width="100%"
      height="100%"
      zIndex={-1}
      sx={{
        background: isEnabled
          ? `linear-gradient(135deg, #fff, ${primaryColor})`
          : `var(--primitives-desktop-gradient-soft-ambient-light)`,
        opacity: {
          xs: isEnabled ? 0.5 : 0.8,
          sm: isEnabled ? 0.5 : 1,
        },
        pointerEvents: "none",
      }}
    />
  )
}
